import { useCallback } from 'react';

import { useFrontAPI } from '../hooks';
import { useStep } from '../UI';
import captureSubmitError from './captureSubmitError';

export function useOrderSubmit(orderId) {
    const { gotoNextStep } = useStep();
    const api = useFrontAPI();

    return useCallback(
        captureSubmitError(async (payload) => {
            await api.orders.update({ orderId, payload });

            gotoNextStep();
        }),
        [orderId, gotoNextStep]
    );
}
